import { useState, useEffect } from 'react'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavItem, NavLink } from 'reactstrap'
import { FaRunning } from 'react-icons/fa'

export default function SchemaMenu() {
  console.log('SchemaMenu rendered')

  const [items, setItems] = useState([])

  useEffect(() => {
    async function fetchItems() {
      const baseAddress = window.location.href.substr(0, window.location.href.split('/', 3).join('/').length)
      const schemas = []
      //console.log(localStorage)
      for (let schema of Object.keys(localStorage)) {
        schemas.push(schema)
      }
      schemas.sort()
      const menuItems = []
      for (let schema of schemas) {
        menuItems.push(
          <DropdownItem key={schema}>
            <NavItem><NavLink href={`${baseAddress}/${schema}/home`}>{schema}</NavLink></NavItem>
          </DropdownItem>
        )
      }
      setItems(menuItems)
    }
    fetchItems()
  }, [])

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret>
        <b><FaRunning style={{verticalAlign: 'baseline'}} /> Schema</b>
      </DropdownToggle>
      <DropdownMenu end style={{maxHeight: '500px', overflow: 'auto'}}>
        {items}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
